import React, { Component } from 'react';
import CommunityList from '../CommunityList';
import Comment from "./../social/shared/post/Comment"
import { COLORS } from '../../styles/colors';
import { NUMBER } from '../../constants';
import NavigationTabs from '../nav/NavigationTabs'
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadMoreIcon from './../LoadMoreIcon';
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
 
  constructor(props) {
    super(props)
    this.state = {
        dataLoaded: false,
        list: [],
        hasMore: false,
        total: 0
    }
  }

  componentWillUnmount() {
    this.timer = null;
  }
  
  componentDidMount() {
    this.timer = setInterval(() => {
      if (this.props.itemType === 'topic') {
        this.getTranscodeItems();
      }
    }, 30000)
    this.fetchItem({
        skip: NUMBER.ZERO,
        limit: NUMBER.TEN
    });
  }

  getTranscodeItems() {
    const ids = [];
    let list = this.state.list;
    for(let i = 0; i < list.length; i++) {
       const l = list[i];
       if (l.isTranscoding) {
        ids.push(l._id)
       }
    }
    if (ids.length > 0) {
      this.props.getTranscodeItems(this.props.postId, this.props.itemType, ids).then((res) => {
        const data = res.data;
        let list = this.state.list;
        list = list.map((l) => {
          const findIndex = data.findIndex((l) => l._id === l._id);
          let obj;
          if (findIndex > -1) {
            obj = {
              isTranscoding: data[findIndex]['isTranscoding'],
              url: data[findIndex]['url']
            }
          }
          return {
            ...l,
            ...obj
          }
        });
        this.setState({
          list: list
        })
      });
    }
  }
  
  fetchItem(req) {
    this.props.fetchListData({
        ...req,
        postId: this.props.postId,
        type: this.props.itemType
    }).then((res) => {
      const updateList = [
        ...this.state.list,
        ...res.data
      ];
      const total = res.metadata.length > 0 ? res.metadata[0].total : 0
      this.setState({
        dataLoaded: true,
        list: updateList,
        hasMore: updateList.length < total,
        total: total
      })
    });
  }

  loadMoreItem = () => {
    this.fetchItem({
      skip: this.state.list.length,
      limit: NUMBER.TEN
    });
  }

  render() {
    let { user, itemType, history, showNavigation } = this.props;
    let { list, hasMore, total } = this.state;
    
    return (
      <div>
        { showNavigation &&
          <NavigationTabs
            title="Manage Community"
            set="manageCommunity"
            subtitle="Topics"
            activeRoute="/community/topics"
            isNewBtn={true}
            newBtnTxt={'New Topic'}
            onClick={() => {
              history.push('/community/topics/add');
            }}
          />
        }

        { (this.state.dataLoaded && list.length === 0 ) &&
            <div style={{  height: 300, textAlign: 'center' }}>
                <h1>No {itemType} Available!</h1>
            </div>
        }

        { this.state.dataLoaded  && 
          <div style={{ marginTop: 10, border: list.length > 0 ? '1px solid ' + COLORS.grey : 0 }}>
              <div id="scrollableDiv" style={{ height: list.length ? 400 : 0, overflow: "auto" }}>
                    <InfiniteScroll
                        dataLength={list.length}
                        next={this.loadMoreItem}
                        hasMore={ hasMore}
                        scrollableTarget="scrollableDiv"
                        loader={<LoadMoreIcon></LoadMoreIcon>}
                    >
                      { itemType === 'comment' ?
                        <div>
                          {list.map((item, index) => {
                            return (<Comment 
                                onDeleteComment={ (id) => {
                                  let cloneList = [...list];
                                  const findIndex = cloneList.findIndex((l) => l._id === id);
                                  if (findIndex > -1) {
                                    cloneList.splice(findIndex, 1);
                                    this.setState({
                                      list: [...cloneList]
                                    })
                                  }
                                  this.props.onDeleteComment(id)
                                }} 
                                onSaveComment={this.props.onSaveComment} 
                                key={item._id} 
                                comment={item} 
                                {...this.props}
                              >
                            </Comment>)
                          })}
                        </div>
                      :
                        <CommunityList
                        items={list}
                        creatorTabs={true}
                        user={user}
                        itemType={itemType}
                        history = {history}
                        deleteItem={this.props.deleteItem }
                        isMobile = { this.props.isMobile }
                        />
                      }
                    </InfiniteScroll>
                </div>
          </div>
        }
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/community/ListCommunityItems.js